import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import OutputText from '@ey/canvascoreservices/OutputText';
import {IconoirProhibition} from '@ey-xd/motif-icon';

import CardBackground from '../../CoreWrappers/CardBackground';
import IconMessage from '../../CoreWrappers/IconMessage';
import StyledTitle from './StyledTitle';
import StyledHeader from './StyledHeader';
import StyledBody from './StyledBody';

const Tile = ({
	title = null,
	subTitle = null,
	header = null,
	subHeader = null,
	footer = null,
	children,
	className = null,
	isEmpty = false,
	emptyTitle = null,
	emptySubtitle = null,
	emptyIcon = IconoirProhibition
}) => {
	const hasTitle = title || subTitle || header;

	const renderTitle = () => (
		<StyledTitle>
			<OutputText h6>{title}</OutputText>
			<OutputText body3 light>
				{subTitle}
			</OutputText>
		</StyledTitle>
	);

	const renderEmptyMessage = () => {
		const props = {
			title: emptyTitle,
			subTitle: emptySubtitle,
			icon: emptyIcon
		};

		return <IconMessage {...props} />;
	};

	const props = {
		className: classNames({[className]: !!className})
	};

	return (
		<CardBackground {...props}>
			<StyledHeader>
				<div className="header">
					{hasTitle && renderTitle()}
					{header && header}
				</div>
				{subHeader && subHeader}
			</StyledHeader>
			<StyledBody className={classNames({empty: isEmpty})}>
				{isEmpty && renderEmptyMessage()}
				{!isEmpty && children}
			</StyledBody>
			{footer && footer}
		</CardBackground>
	);
};

export default Tile;

Tile.propTypes = {
	title: PropTypes.string,
	subTitle: PropTypes.string,
	header: PropTypes.element,
	footer: PropTypes.element,
	subHeader: PropTypes.element
};
